/**
 * Created by yniran on 12/13/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEResourceResolver = require("leResourceResolver"),
        BaseCollection = require("collections/BaseCollection"),
        ChatContactModel = require("connection-models/chatTab/ChatContactModel"),
        ChatContactsCollection = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {


        var logger = LEConnection.logger;

        ChatContactsCollection = BaseCollection.extend({

            resource: function () {
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                var publicStr = isAuthenticated ? "" : "public/";
                LEResourceResolver.addConfigValue("publicPath", publicStr);
                if (this._contactType === CP_CONST.CONTACT_TYPE.UNDEFINED){
                    return LEResourceResolver.apiResources.ConnectionPanel.Groups;
                } else {
                    throw new Error('specific contact type not supported');
                }
            },

            model: ChatContactModel,

            defaults: {
                availability: false//CP_CONST.CONTACT_STATES.OFFLINE
            },

            initialize: function (models, options) {

                this._filterInfo = null;
                this._chatChannel = options.chatChannel;
                this._contactTypes = options.contactTypes;
                this._bindEvents();
            },

            getContactTypes: function () {
                return this._contactTypes;
            },

            getMessagingContacts: function () {
                return this.where({"engagementType": "messaging"});
            },

            _bindEvents: function () {
                this.listenTo(this, "organize:filter", this._onOrganizeFilter);
                this.listenTo(this, 'change:notificationCounter', this._onContactNotificationCounterChanged);
            },

            parse: function (resp) {
                // when Common.BlockSupportAccess feature is on then display only teams that are not marked as paidOnly
                // basically remove support team
                if(LE){
                    if(LE.sessionManager.hasBlockSupportAccessFeature() || LE.sessionManager.getActivePersona() === LE.sessionManager.PERSONA.GUEST){
                        //only return teams that are paidOnly false
                        resp = _.filter(resp, function(contact){
                            return !contact.paidOnly;
                        });
                    }
                }
                return resp;
            },

            getFilterInfo: function () {
                return this._filterInfo;
            },

            _onOrganizeFilter: function (info) {
                this._filterInfo = info;
            },

            //calculate the accumulated counter and publish it
            // don´t bother incrementing the existing counter, because a counter may have been reset
            _onContactNotificationCounterChanged: function (model, value){

                var accumulated = this.models.reduce(
                   function(sum, contact){
                       return sum + (contact.getNotificationCounter() || 0 );
                   }, 0);
                LEConnection.vent.trigger('chat:notifications:accumulatedChanged', accumulated);

            }
        });
    });

    return ChatContactsCollection;
});
